import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { useQuery as useAchLinkingOfferEligibilityQuery } from "@faire/web-api--source/api/instrument/ach-linking-offer-eligibility/get-hooks";
import { useQuery as useOrdersTabCountsQuery } from "@faire/web-api--source/api/order/v2/brand-order-group-counts-by-tab/get-hooks";
import { QueryParameters as BrandFollowsParams } from "@faire/web-api--source/api/v2/retailers/retailerToken/follows/scroll/get";
import { useQuery as useBrandFavoritesQuery } from "@faire/web-api--source/api/v2/retailers/retailerToken/follows/scroll/get-hooks";
import { IAchLinkingOfferEligibilityResponse } from "@faire/web-api--source/indigofair/data/IAchLinkingOfferEligibilityResponse";
import { IGetAchMessagingResponse } from "@faire/web-api--source/indigofair/data/IGetAchMessagingResponse";
import { RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP";
var VALID_DROPDOWN_OFFERS = [
    IGetAchMessagingResponse.AchOfferType.PROACTIVE_LIMIT_INCREASE,
    IGetAchMessagingResponse.AchOfferType.TERMS_PRE_APPROVAL_ACH_LINK
];
// This is used to fetch the data for the revamped dropdown menu in the header account section.
// We want to fetch this before the user opens the dropdown so that the data is ready to be displayed.
export var useRevampedDropdownData = function() {
    var _brandFavoritesData_follows;
    var isNewUser = useRetailerStore([
        "isNewUser"
    ]).isNewUser;
    var retailerToken = useRetailer().retailerToken;
    var _usePOSSummary = usePOSSummary(), isLinked = _usePOSSummary.isLinked, name = _usePOSSummary.name, reviewCount = _usePOSSummary.reviewCount;
    var _useMilestone = useMilestone(RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP), hasSeenR2BHeartIconNotification = _useMilestone.hasOccurred;
    var _useBrandFavoritesQuery = useBrandFavoritesQuery(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", BrandFollowsParams.build({}), {
        enabled: !hasSeenR2BHeartIconNotification,
        staleTime: Infinity
    }), brandFavoritesData = _useBrandFavoritesQuery.data;
    var _useOrdersTabCountsQuery = useOrdersTabCountsQuery({
        staleTime: Infinity
    }), ordersTabCountsData = _useOrdersTabCountsQuery.data;
    var _useAchLinkingOfferEligibilityQuery = useAchLinkingOfferEligibilityQuery({
        surface: IAchLinkingOfferEligibilityResponse.AchOfferSurface.ACCOUNT_DROPDOWN
    }, {
        staleTime: Infinity
    }), achData = _useAchLinkingOfferEligibilityQuery.data;
    var _ordersTabCountsData_action_required_count;
    var numOfPendingOrders = (_ordersTabCountsData_action_required_count = ordersTabCountsData === null || ordersTabCountsData === void 0 ? void 0 : ordersTabCountsData.action_required_count) !== null && _ordersTabCountsData_action_required_count !== void 0 ? _ordersTabCountsData_action_required_count : 0;
    var newFollows = !hasSeenR2BHeartIconNotification ? brandFavoritesData === null || brandFavoritesData === void 0 ? void 0 : (_brandFavoritesData_follows = brandFavoritesData.follows) === null || _brandFavoritesData_follows === void 0 ? void 0 : _brandFavoritesData_follows.length : 0;
    var _achData_ach_offer_type;
    var achOfferData = (achData === null || achData === void 0 ? void 0 : achData.is_eligible) && VALID_DROPDOWN_OFFERS.includes((_achData_ach_offer_type = achData === null || achData === void 0 ? void 0 : achData.ach_offer_type) !== null && _achData_ach_offer_type !== void 0 ? _achData_ach_offer_type : "") ? achData : undefined;
    return {
        isLinked: isLinked,
        name: name,
        reviewCount: reviewCount,
        numOfPendingOrders: numOfPendingOrders,
        isNewUser: isNewUser,
        newFollows: newFollows,
        achOfferData: achOfferData
    };
};
